export default{
      header: {
        welcome: "مرحبا",
        search_placeholder: "ابحث عن المنتجات...",
        my_products: "منتجاتي",
        add_product: "إضافة منتج",
        orders: "الطلبات",
        offers: "العروض",
        reports: "التقارير",
        support: "الدعم",
        help: "مساعدة",
        control_tower: "لوحة التحكم",
        supplier_approval: "موافقة الموردين",
        restaurant_approval: "موافقة المطاعم",
        credit_management: "إدارة الائتمان",
        monitoring: "المراقبة",
        promotions: "العروض",
        promotion_request: "طلبات العروض",
        paid_promotions: "العروض المدفوعة",
        coupon_management: "إدارة الكوبونات",
        support_tickets: "تذاكر الدعم",
        credit_settlement: "تسوية الائتمان",
        supplier_payments: "مدفوعات الموردين",
        profile_changes: "تغييرات الملف الشخصي",
        user_management: "إدارة المستخدمين",
        create_user: "إنشاء مستخدم",
        logout: "تسجيل الخروج",
        overview: "نظرة عامة",
        today_orders: "طلبات اليوم",
        active_suppliers: "الموردون النشطون",
        admin: "مدير",
        orders_trend: "اتجاه الطلبات",
        revenue_trend: "اتجاه الإيرادات",
        top_suppliers: "أفضل الموردين",
        recent_activity: "النشاط الأخير",
        system_insights: "رؤى النظام",
        pending_orders: "الطلبات المعلقة",
        failed_orders: "الطلبات الفاشلة",
        active_restaurants: "المطاعم النشطة",
        today_revenue: "إيرادات اليوم",
        monthly_revenue: "الإيرادات الشهرية",
        open_tickets: "التذاكر المفتوحة",
        credit_given: "الائتمان الممنوح",
        credit_collected: "الائتمان المحصل",
        outstanding_credit: "الائتمان المستحق",
        overdue_credit: "الائتمان المتأخر",
        avg_order_value: "متوسط قيمة الطلب",
        success_rate: "معدل النجاح",
        cancellation_rate: "معدل الإلغاء",
        needs_attention: "يحتاج إلى انتباه",
        order_status: "حالة الطلب",
        today: "اليوم",
        days: "أيام",
        month: "الشهر",
        financial_health: "المالية والصحة",
        credit_risk_restaurants: "مخاطر الائتمان للمطاعم",
        inactive_suppliers: "الموردون غير النشطين",
        order: "الطلب",
        status: "الحالة",
        date: "التاريخ",
        stuck_orders: "طلبات عالقة",
        failed_payments: "مدفوعات فاشلة",
        pending_suppliers: "موردون قيد الانتظار",
        high_priority_tickets: "تذاكر عالية الأولوية",
        sla_breach: "خرق مستوى الخدمة",
      },
      sidebar: {
        overview: "نظرة عامة",
        basic_info: "المعلومات الأساسية",
        supplier_info: "معلومات المورد",
        restaurant_info: "معلومات المطعم",
        address: "العنوان",
        bank: "تفاصيل البنك",
        documents: "المستندات",
        supplier_branch: "فروع المورد",
        restaurant_branch: "فروع المطعم",
        supplier_store: "متاجر المورد",
        restaurant_store: "متاجر المطعم",
        settings: "الإعدادات",

        back_to_dashboard: "العودة إلى لوحة التحكم",
        supplier: "مورد",
        restaurant: "مطعم",
        complete: "مكتمل"
      },
      overview: {
        profile_completed: "اكتمل الملف الشخصي",
        supplier_profile: "ملف المورد",
        restaurant_profile: "ملف المطعم",
        verified: "تم التحقق",
        rejected: "مرفوض",
        pending_verification: "قيد التحقق",
        completed: "مكتمل",
        incomplete: "غير مكتمل",
        basic_info: "المعلومات الأساسية",
        company: "الشركة",
        address: "العنوان",
        bank: "البنك",
        branches: "الفروع",
        store: "المتجر",
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        cr_number: "رقم السجل التجاري",
        vat_number: "الرقم الضريبي",
        city: "المدينة",
        bank: "البنك",
        iban: "رقم الآيبان",
        total_branches: "إجمالي الفروع",
      },
      basicinfo: {
        title: "المعلومات الأساسية",
        full_name: "الاسم الكامل",
        company_name: "اسم الشركة",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        profile_type: "نوع الحساب",
        edit: "تعديل",
        next: "التالي →",
        save_next: "حفظ والمتابعة →",
        saving: "جارٍ الحفظ...",
        no_edit: "لا يمكن تعديل المعلومات الأساسية",
        invalid_email: "البريد الإلكتروني غير صالح ❌",
        invalid_phone: "رقم الهاتف غير صالح ❌",
        no_data: "لا توجد بيانات للحفظ ❌",
        saved: "تم الحفظ ✅",
        sent_for_approval: "تم الإرسال للموافقة ✅",
      },
      companyinfo: {
        title_supplier: "تفاصيل المورد",
        title_restaurant: "تفاصيل المطعم",
        company_name_supplier: "اسم شركة المورد",
        company_name_restaurant: "اسم المطعم",
        email: "البريد الإلكتروني",
        cr_number: "رقم السجل التجاري",
        cr_expiry: "تاريخ انتهاء السجل",
        comp_card_number: "رقم بطاقة الكمبيوتر",
        comp_card_expiry: "تاريخ انتهاء البطاقة",
        signing_authority: "المخول بالتوقيع",
        sponsor_name: "اسم الكفيل",
        trade_license: "اسم الرخصة التجارية",
        vat_number: "الرقم الضريبي",
        category: "الفئة",
        brand_name: "اسم العلامة التجارية",
        edit: "تعديل",
        saving: "جارٍ الحفظ...",
        next: "التالي →",
        save_next: "حفظ والمتابعة →",
        digits_6_10: "أرقام فقط (6 إلى 10 أرقام)",
        digits_7_12: "أرقام فقط (7 إلى 12 رقمًا)",
        vat_hint: "رقم ضريبي مكون من 15 رقمًا",
        trade_license_hint: "يجب أن يطابق الرخصة التجارية تمامًا",
        email_placeholder: "بريد الشركة الإلكتروني",
      },
      address: {
        title: "معلومات العنوان",
        address: "العنوان",
        street: "الشارع",
        zone: "المنطقة",
        area: "الحي",
        city: "المدينة",
        country: "الدولة",
        select: "اختر"
      },
      profilebank: {
        title: "تفاصيل البنك",
        bank_name: "اسم البنك",
        account_holder: "اسم صاحب الحساب",
        branch: "الفرع",
        iban: "رقم الآيبان",
        swift: "رمز السويفت",
        iban_hint: "مطلوب للمدفوعات الدولية",
        swift_hint: "يستخدم للتحويلات الدولية",
        bank_name_placeholder: "مثال: بنك HDFC",
        account_holder_placeholder: "الاسم حسب السجل البنكي",
        branch_placeholder: "اسم الفرع",
        iban_placeholder: "رمز الدولة + الرقم",
        swift_placeholder: "8 أو 11 حرفًا"
      },
      documents: {
        title: "المرفقات",
        cr_copy: "نسخة السجل التجاري",
        comp_card: "نسخة بطاقة الكمبيوتر",
        trade_license: "نسخة الرخصة التجارية",
        vat_certificate: "شهادة ضريبة القيمة المضافة",
        company_logo: "شعار الشركة",
        bank_letter: "خطاب البنك",
        certificates: "الشهادات",
        food_safety: "شهادة سلامة الغذاء",
        upload_file: "رفع ملف",
        uploaded_file: "تم رفع الملف",
        no_file: "لم يتم اختيار ملف",
        choose_file: "اختر ملف",
      },
      branch: {
        title_supplier: "تسجيل فروع المورد",
        title_restaurant: "تسجيل فروع المطعم",
        multiple: "هل لديك فروع متعددة؟",
        total: "إجمالي الفروع",
        branch_progress: "الفرع {{current}} من {{total}}",

        branch_name_en: "اسم الفرع (إنجليزي)",
        branch_name_ar: "اسم الفرع (عربي)",
        manager: "مدير الفرع",
        contact: "رقم الاتصال",
        email: "البريد الإلكتروني",
        street: "الشارع",
        zone: "المنطقة",
        building: "المبنى",
        office: "رقم المكتب",
        city: "المدينة",
        country: "الدولة",
        license: "رخصة الفرع",
      },
      store: {
        title_supplier: "تفاصيل متجر المورد",
        title_restaurant: "تفاصيل متجر المطعم",
        branch: "الفرع",
        select_branch: "اختر الفرع",
        name_en: "اسم المتجر (إنجليزي)",
        name_ar: "اسم المتجر (عربي)",
        contact_name: "اسم الشخص المسؤول",
        contact_mobile: "رقم الهاتف",
        email: "البريد الإلكتروني",
        street: "الشارع",
        zone: "المنطقة",
        city: "المدينة",
        building: "المبنى",
        shop: "رقم المحل",
        hours: "ساعات العمل",
        store_type: "نوع المتجر",
        retail: "تجزئة",
        warehouse: "مستودع",
        delivery_pickup: "التوصيل / الاستلام",
        delivery: "توصيل",
        pickup: "استلام",
        both: "كلاهما",
        hours_placeholder: "9:00 ص - 6:00 م",
        store_placeholder: "أدخل اسم المتجر",
        mobile_digits: "يجب أن يكون 10 أرقام",
      },
      settings: {
        title: "إعدادات الحساب",
        preferences: "التفضيلات",
        notifications: "الإشعارات",
        profile: "إعدادات الملف الشخصي",
        security: "الأمان",

        language: "اللغة",
        timezone: "المنطقة الزمنية",
        currency: "العملة",

        email_notify: "إشعارات البريد الإلكتروني",
        sms_notify: "إشعارات الرسائل",
        whatsapp_notify: "إشعارات واتساب",
        order_updates: "تحديثات الطلبات",
        promo_alerts: "العروض الترويجية",

        profile_visible: "ملف المورد العام",
        show_contact: "إظهار معلومات الاتصال",

        two_factor: "المصادقة الثنائية",
        login_alerts: "تنبيهات تسجيل الدخول",
        device_verification: "التحقق من الجهاز",

        save: "حفظ الإعدادات"
      },
      alerts: {
        no_edit: "لا يمكن تعديل المعلومات الأساسية",
        invalid_email: "البريد الإلكتروني غير صالح ❌",
        invalid_phone: "رقم الهاتف غير صالح ❌",
        no_data: "لا توجد بيانات للحفظ ❌",
        saved: "تم الحفظ ✅",
        sent_for_approval: "تم الإرسال للموافقة ✅",
        session_expired: "انتهت الجلسة ❌",
        no_changes: "لا توجد تغييرات",
        no_changes_address: "لا توجد تغييرات في العنوان",
        update_failed: "فشل التحديث ❌",
        no_changes_bank: "لا توجد تغييرات في بيانات البنك",
        no_changes_documents: "لا توجد تغييرات في المستندات",
        no_files: "لم يتم اختيار أي ملف ❌",
        save_failed: "فشل الحفظ ❌",
        error_saving: "خطأ أثناء حفظ الملفات ❌",
        no_changes_branch: "لا توجد تغييرات في الفروع", 
        no_changes_store: "لا توجد تغييرات في المتجر",
        error_saving_store: "خطأ في حفظ المتجر ❌"
      },
      buttons: {
        edit: "تعديل",
        saving: "جارٍ الحفظ...",
        next: "التالي",
        save_next: "حفظ والمتابعة",
        back: "رجوع",
        previous: "الفرع السابق",
        next_branch: "حفظ والانتقال للفرع التالي",
        finish: "إنهاء"
      },
      validation: {
        cr_number: "يجب أن يكون السجل التجاري 6 إلى 10 أرقام",
        vat_number: "يجب أن يكون الرقم الضريبي 15 رقمًا",
        required: "مطلوب",
        required_field: "{{field}} مطلوب"
      },
      common: {
        select: "اختر",   // "Select"
        // select: "يرجى الاختيار",   // "Please select"
        yes: "نعم",
        no: "لا"
      }
    }